import './LMPChartPanel.scss';
import LMPChartPanel from './LMPChartPanel';

export default LMPChartPanel;
